import API from "./config"
import { USER_ACTIVITY_LOGGING_URL, USER_ACTIVITY_API_PARAMS } from "api/UserActivityConstants";

export default class LoggingAPI {

    static async logUserActivity(request_data) {
        try {
            // Make a POST request to the /user_activity/register endpoint
            const response = await API.post(USER_ACTIVITY_LOGGING_URL, request_data);
            // Return the response from the API call
            return response.data;
        } catch (error) {
            // Handle errors, e.g., log them or rethrow them
            console.error("Failed to log user activity:", error);
            throw error;
        }
    }
}


export function logActivity({screen, action_type, action, action_target}) {
    const logData = {
        [USER_ACTIVITY_API_PARAMS.ROUTE]: window.location.pathname,
        [USER_ACTIVITY_API_PARAMS.SCREEN]: screen,
        [USER_ACTIVITY_API_PARAMS.ACTION_TYPE]: action_type,
        [USER_ACTIVITY_API_PARAMS.ACTION]: action,
        [USER_ACTIVITY_API_PARAMS.ACTION_TARGET]: action_target,
    };
    
    
    LoggingAPI.logUserActivity(logData)
        .then(response => {
            // Handle successful response
        })
        .catch(error => {
            console.error("Error logging activity:", error);
        })
}
